import { EditionAwarenessContextType } from './edition-awareness-context';

export const isEligibleForAutomationLimits = (context: EditionAwarenessContextType) => {
	const { edition, product, automationDailyUsage, automationWeeklyUsage } = context;
	return (
		edition === 'free' &&
		product === 'jira' &&
		(isAutomationProjectedToBreach(automationWeeklyUsage ?? 0) ||
			hasAutomationBreached(automationDailyUsage ?? 0))
	);
};

export const isAutomationProjectedToBreach = (automationUsageWeekly: number) => {
	// Based on the weekly usage from the first week, we calculate if the projected usage will exceed 80%
	return (automationUsageWeekly / 7) * 30 > 80;
};

export const hasAutomationBreached = (automationUsageDaily: number) => {
	return automationUsageDaily > 100;
};
